"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AttributeDropdownList = exports.MAX_SELECTION_SIZE = void 0;
var tslib_1 = require("tslib");
// (C) 2019-2021 GoodData Corporation
var react_1 = tslib_1.__importStar(require("react"));
var react_intl_1 = require("react-intl");
var sdk_ui_kit_1 = require("@gooddata/sdk-ui-kit");
var AttributeFilterItem_1 = require("./AttributeFilterItem");
var types_1 = require("./types");
var ITEM_HEIGHT = 28;
var MOBILE_LIST_ITEM_HEIGHT = 40;
exports.MAX_SELECTION_SIZE = 500;
var VISIBLE_ITEMS_COUNT = 10;
var ListLoading = function () { return react_1.default.createElement(sdk_ui_kit_1.LoadingMask, { height: 306 }); };
var ListError = function () { return (react_1.default.createElement("div", { className: "gd-message error" },
    react_1.default.createElement(react_intl_1.FormattedMessage, { id: "gs.list.error" }))); };
exports.AttributeDropdownList = function (_a) {
    var items = _a.items, totalCount = _a.totalCount, error = _a.error, isLoading = _a.isLoading, selectedItems = _a.selectedItems, isInverted = _a.isInverted, onRangeChange = _a.onRangeChange, onSelect = _a.onSelect, onSearch = _a.onSearch, searchString = _a.searchString, isMobile = _a.isMobile;
    if (error) {
        return react_1.default.createElement(ListError, null);
    }
    var getItemKey = react_1.useCallback(function (i) {
        var _a;
        var isSelectionByUri = !!((_a = selectedItems[0]) === null || _a === void 0 ? void 0 : _a.uri);
        return types_1.isNonEmptyListItem(i) ? (isSelectionByUri ? i.uri : i.title) : "empty";
    }, []);
    var itemHeight = isMobile ? MOBILE_LIST_ITEM_HEIGHT : ITEM_HEIGHT;
    return (react_1.default.createElement(sdk_ui_kit_1.LegacyInvertableList, { items: items, itemsCount: totalCount, filteredItemsCount: totalCount, selection: selectedItems, isLoading: isLoading, isLoadingClass: ListLoading, noItemsFound: !items.length, isInverted: isInverted, showSearchField: true, onSearch: onSearch, searchString: searchString, rowItem: react_1.default.createElement(AttributeFilterItem_1.AttributeFilterItem, null), maxSelectionSize: exports.MAX_SELECTION_SIZE, itemHeight: itemHeight, height: itemHeight * VISIBLE_ITEMS_COUNT, onRangeChange: onRangeChange, onSelect: onSelect, getItemKey: getItemKey }));
};
//# sourceMappingURL=AttributeDropdownList.js.map